import React from 'react'
import '../styles/homepage.scss'

class Carousel extends React.Component {  
  render() {
    return (
      <div className="carousel">
        <div className="third">
          1
        </div>
        <div className="third">
          12
        </div>
         <div className="third">
          13
         </div>

      </div>
    )
  }
}
export default Carousel



// WEBPACK FOOTER //
// ./src/components/Carousel.jsx